// Get elements and dataset configurations
// Safe DOM Element Selection
const cartData = document.getElementById("cart-data");

// Safely extract dataset values without throwing Uncaught TypeError
const cartId = cartData && cartData.dataset ? cartData.dataset.cartId : "";
const cartTotal = cartData && cartData.dataset ? parseFloat(cartData.dataset.total) || 0 : 0;
const originalTotal = cartTotal;

let promoDiscount = 0;
let promo_code = ""; // Tracks applied coupon code string globally
const prepaidDiscount = 85;
let prepaidSelected = false;

// DOM Elements
const totalUI = document.getElementById("final_total_ui");
const proceed_checkout_price = document.getElementById("proceed_checkout_price");
const total_hidden = document.getElementById("final_amount_id");
const paymentSelect = document.getElementById("payment_method");
const prepaidBox = document.getElementById("prepaid_discount_box");

const codBtn = document.getElementById("cod-btn");
const rzpBtn = document.getElementById("rzp-button1");

// Clean Cookie Extractor helper function
function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

function updateAmounts() {
    let finalTotal = originalTotal;

    // Apply promo discount
    finalTotal -= promoDiscount;

    // Safe check for paymentSelect before accessing .value
    if (paymentSelect && paymentSelect.value === "online") {
        finalTotal -= prepaidDiscount;
        if (prepaidBox) prepaidBox.classList.remove("hidden");
        if (codBtn) codBtn.classList.add("hidden");
        if (rzpBtn) rzpBtn.classList.remove("hidden");
        prepaidSelected = true;
    } else {
        if (prepaidBox) prepaidBox.classList.add("hidden");
        if (codBtn) codBtn.classList.remove("hidden");
        if (rzpBtn) rzpBtn.classList.add("hidden");
        prepaidSelected = false;
    }

    finalTotal = Math.max(finalTotal, 0).toFixed(2);
    
    // UI Updates
    if (totalUI) totalUI.innerText = "₹" + finalTotal;
    if (proceed_checkout_price) proceed_checkout_price.innerText = "₹" + finalTotal;
    if (total_hidden) total_hidden.value = finalTotal;
    if (rzpBtn) rzpBtn.innerText = "Pay Now ₹" + finalTotal;
    
    return finalTotal;
}

// Event listener for dropdown changes
paymentSelect.addEventListener("change", updateAmounts);

// Promocode Application System
document.getElementById("apply_promo_btn").addEventListener("click", async function () {
    const code = document.getElementById("promo_input").value.trim();
    const msg = document.getElementById("promo_message");
    const hiddenPromoInput = document.getElementById("promocode_code_hidden");

    if (!code) {
        msg.innerHTML = "Please enter a promocode.";
        msg.style.color = "red";
        return;
    }

    try {
        const url = `/api/promo/apply-promocode/?code=${encodeURIComponent(code)}&cart_id=${cartId}`;
        const res = await fetch(url, {
            method: "GET",
            headers: { "Accept": "application/json" },
            credentials: "include"
        });

        const data = await res.json();
        if (data.success === false) {
            msg.innerHTML = data.msg;
            msg.style.color = "red";
            promoDiscount = 0;
            promo_code = ""; // Clear state tracking
            if (hiddenPromoInput)
            {
                hiddenPromoInput.value = "";
            }
            msg.className = "mt-3 flex items-center gap-2 p-3 text-sm rounded-lg border bg-rose-50 text-rose-800 border-rose-200 dark:bg-rose-950/40 dark:text-rose-300 dark:border-rose-800";
            msg.innerHTML = `
            <svg class="w-4 h-4 text-rose-600 dark:text-rose-400 shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
            </svg>
            <span>${data.msg || "Invalid promo code"}</span>
            `;
            updateAmounts();
        } else if  (data.success === true) {
            // msg.innerHTML = `🎉 ${data.msg} You saved ₹${data.discount}`;
            msg.style.color = "green";
            
            promoDiscount = parseFloat(data.discount);
            promo_code = code;

            if (hiddenPromoInput)
            {
                hiddenPromoInput.value = code;
            } 
            msg.className = "mt-3 flex items-center justify-between p-3 text-sm rounded-lg border bg-emerald-50 text-emerald-800 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-800";
            msg.innerHTML = `
            <div class="flex items-center gap-2">
                <svg class="w-4 h-4 text-emerald-600 dark:text-emerald-400 shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span>${data.msg || "Promo code applied!"}</span>
            </div>
            <span class="font-bold text-emerald-700 dark:text-emerald-200">Saved ₹${promoDiscount}</span>
            `;
            updateAmounts();
        }

    } catch (error) {
        console.error(error);
        msg.innerHTML = "Something went wrong. Try again.";
        msg.style.color = "red";
        promo_code = "";
        if (hiddenPromoInput) hiddenPromoInput.value = "";
        updateAmounts();
    }
});

// Clean trigger pointing directly to the processing method framework
rzpBtn.onclick = function (e) {

    e.preventDefault();
    // 1. Hidden input ya dataset se selected address ID check karein
    const addressInput = document.getElementById("shipping-address-hidden");
    const cartDataNode = document.getElementById("cart-data");

    const addressId = addressInput ? addressInput.value : (cartDataNode ? cartDataNode.dataset.addressId : null);

    // 2. Agar Address ID empty/missing hai, toh New Address page par redirect karein
    if (!addressId || addressId.trim() === "" || addressId === "None") {
        window.location.href = "/account/address/new/?next=/checkout/";
        return;
    }
    createRazorpayOrder();
};

async function createRazorpayOrder() {
    const csrftoken = getCookie('csrftoken');
    const razorpay_key = cartData.dataset.razorpayKey;
    const email = cartData.dataset.email;
    const phone = cartData.dataset.phone;
    const prepaid = prepaidSelected;
    const addressId = document.getElementById("shipping-address-hidden")?.value;

    try {
        const res = await fetch("/api/order/create-order/", {
            method: "POST",
            credentials: 'same-origin',
            headers: { 
                "Content-Type": "application/json",
                "X-CSRFToken": csrftoken
            },
            body: JSON.stringify({
                cart_id: cartId,
                promo_code: promo_code,
                prepaid: prepaid,
                address_id: addressId
            })
        });

        const data = await res.json();

        if (!data.success) {
            alert(data.msg);
            return;
        }

        var options = {
            "key": razorpay_key,
            "amount": data.final_amount_paise,
            "currency": "INR",
            "name": "Zyonic Store",
            "description": "Payment Transaction",
            "image": "https://zyonicstore.com/static/pubimage/logo_designed_.png",
            "order_id": data.order_id,
            "callback_url": window.location.origin + "/api/order/razorpay-callback/",
            "redirect": true,
            "prefill": {
                "email": email,
                "contact": phone
            },
            "theme": {
                "color": "#0F172A" // Color updated to match your new premium dark slate layout grid theme
            }
        };

        const rzp = new Razorpay(options);
        
        rzp.on("payment.failed", function(response) {
            console.error("Payment failed:", response.error);
            alert("Payment failed: " + response.error.description);
        });

        rzp.open();
        
    } catch (err) {
        console.error("Order creation processing exception: ", err);
        alert("Unable to reach transaction processing nodes. Please try again.");
    }
}